module.exports = __webpack_public_path__ + "img/05_bg.a712ae46.png";